import { render, staticRenderFns } from "./ValidadorFirma.vue?vue&type=template&id=792faec9&"
import script from "./ValidadorFirma.vue?vue&type=script&lang=js&"
export * from "./ValidadorFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports